import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import MobileFab from 'components/Layout/MobileShell/MobileFab';
import MobileListState from 'components/Layout/MobileShell/MobileListState';
import ADMIN_SECTION_TABS from 'constants/adminSectionTabs';
import { FluxAboutDocument } from 'types/Flux/About/fluxAboutDocument';

import DocumentCard from './DocumentCard';

import './index.scss';

export default function AboutMobile({
  documents,
  isFetching,
  onEdit,
  onDelete,
  onCreate,
}: {
  documents: FluxAboutDocument[] | undefined,
  isFetching: boolean,
  onEdit: (doc: FluxAboutDocument) => void,
  onDelete: (doc: FluxAboutDocument) => void,
  onCreate: () => void,
}) {
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);

  const resultsCount = documents?.length || 0;

  return (
    <div className="about-mobile">
      <MobileSectionHeader
        backLabel="Administração"
        title="Sobre"
        onBack={() => navigate('/admin')}
        onAvatarClick={() => setMoreOpen(true)}
      />
      <SectionTabs tabs={ADMIN_SECTION_TABS} sheetTitle="Administração" />

      <div className="about-mobile-content">
        <MobileListState
          loading={isFetching}
          isEmpty={resultsCount === 0}
          emptyMessage="Nenhum documento encontrado."
        >
          {documents?.map((document) => (
            <DocumentCard
              key={document.id}
              document={document}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </MobileListState>
      </div>

      <MobileFab label="Adicionar" onClick={onCreate} />

      <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
    </div>
  );
}
